pk-lazy {
  @apply invisible;
  min-width: 1px;
  min-height: 1px;

  > * {
    @apply hidden;
  }
}
